/**
 * Step 3: Questionário de Suitability
 */
import type { StepWithScoreProps } from "./types.js";
import { Radio } from "./FormElements.jsx";

export function Step3Suitability({ form, onChange, T, score, scoreColor }: StepWithScoreProps) {
  const set = (key: string, value: unknown) => onChange(key, value);

  const radio = (name: string, key: string, val: string | number, lbl: string, desc?: string) => (
    <Radio
      name={name}
      checked={form[key] === val}
      onChange={() => set(key, val)}
      label={lbl}
      description={desc}
      T={T}
      isSelected={form[key] === val}
    />
  );

  return (
    <>
      <h3 style={{ fontSize: 15, fontWeight: 700, color: T.text, margin: "0 0 6px" }}>
        4. Questionário de Suitability
      </h3>
      <p style={{ fontSize: 12, color: T.sub, margin: "0 0 18px" }}>
        Resolução CVM 30 – Obrigatório para adequação das recomendações de investimento.
      </p>

      <div style={{ marginBottom: 18 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: T.text, marginBottom: 10 }}>
          4.1. Formação e experiência com o mercado financeiro:
        </div>
        {radio("expNivel", "expNivel", 1, "Nível 1 – Básico", "Poupança, CDBs e Tesouro Direto.")}
        {radio(
          "expNivel",
          "expNivel",
          2,
          "Nível 2 – Intermediário",
          "Fundos de Investimento, Ações e Fundos Imobiliários."
        )}
        {radio(
          "expNivel",
          "expNivel",
          3,
          "Nível 3 – Avançado",
          "Derivativos, Opções, Criptoativos e Ativos Internacionais."
        )}
      </div>

      <div style={{ marginBottom: 18 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: T.text, marginBottom: 10 }}>
          4.2. Reação perante desvalorização momentânea de 10% na carteira:
        </div>
        {radio(
          "reacaoQueda",
          "reacaoQueda",
          "conservador",
          "Conservador",
          "Venderia os ativos para evitar perdas maiores."
        )}
        {radio(
          "reacaoQueda",
          "reacaoQueda",
          "moderado",
          "Moderado",
          "Manteria a posição e aguardaria a recuperação."
        )}
        {radio(
          "reacaoQueda",
          "reacaoQueda",
          "arrojado",
          "Arrojado",
          "Aproveitaria para aumentar a posição a preços menores."
        )}
      </div>

      <div style={{ marginBottom: 18 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: T.text, marginBottom: 10 }}>
          4.3. Declaração de Investidor Qualificado (CVM 539):
        </div>
        <label
          style={{
            display: "flex",
            gap: 10,
            alignItems: "flex-start",
            padding: "11px 12px",
            borderRadius: 9,
            cursor: "pointer",
            background: form.investQualif === true ? `${T.accent}14` : T.bg,
            border: `1px solid ${form.investQualif === true ? T.accent : T.border}`,
            marginBottom: 6,
          }}
        >
          <input
            type="radio"
            name="investQualif"
            checked={form.investQualif === true}
            onChange={() => set("investQualif", true)}
          />
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: T.text }}>
              Sim – Investidor Qualificado
            </div>
            <div style={{ fontSize: 11, color: T.sub }}>
              Possuo investimentos financeiros superiores a R$ 1.000.000 e conhecimento técnico para
              compreender os riscos.
            </div>
          </div>
        </label>
        <label
          style={{
            display: "flex",
            gap: 10,
            alignItems: "flex-start",
            padding: "11px 12px",
            borderRadius: 9,
            cursor: "pointer",
            background: form.investQualif === false ? `${T.accent}14` : T.bg,
            border: `1px solid ${form.investQualif === false ? T.accent : T.border}`,
          }}
        >
          <input
            type="radio"
            name="investQualif"
            checked={form.investQualif === false}
            onChange={() => set("investQualif", false)}
          />
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: T.text }}>
              Não – Investidor Varejo
            </div>
          </div>
        </label>
      </div>

      <div style={{ marginBottom: 18 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: T.text, marginBottom: 10 }}>
          4.4. Horizonte Temporal dos Investimentos:
        </div>
        {radio("horizonte", "horizonte", "curto", "Curto Prazo", "Até 1 ano.")}
        {radio("horizonte", "horizonte", "medio", "Médio Prazo", "De 1 a 5 anos.")}
        {radio("horizonte", "horizonte", "longo", "Longo Prazo", "Acima de 5 anos.")}
      </div>

      {/* Score preview */}
      <div
        style={{
          background: `${scoreColor}15`,
          border: `1px solid ${scoreColor}50`,
          borderRadius: 10,
          padding: "14px 18px",
        }}
      >
        <div
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: scoreColor,
            textTransform: "uppercase",
            letterSpacing: 0.8,
            marginBottom: 4,
          }}
        >
          📊 Resultado Parcial do Suitability
        </div>
        <div style={{ fontSize: 22, fontWeight: 800, color: scoreColor }}>
          {score.perfil}{" "}
          <span style={{ fontSize: 13, fontWeight: 400, color: T.sub }}>
            ({score.score}/{score.max} pontos)
          </span>
        </div>
      </div>
    </>
  );
}
